<template>
  <span class="table-action">
    <span
      v-for="(item, index) in list"
      :key="index"
      :class="[item.action, 'action']"
    >
      <hy-upload
        v-if="item.action==='import'"
        ref="fileUpload"
        :accept="'.xls,.xlsx'"
        :upload-params="{ code: 'creative-platform', app: 'op'}"
        :is-show-list="false"
        @success="successEvent"
      >
        <template slot="content"> <!-- 自定义上传样式 -->
          <a-button
            :type="item.type || 'default'"
            :ghost="item.ghost"
          >{{ item.title }}</a-button>
        </template>
      </hy-upload>

      <a-button
        v-else
        v-show="(record.edit === undefined && record.delete === undefined) || (record.edit && item.action === 'edit') || (record.delete && item.action === 'delete')"
        :type="item.type || 'default'"
        :ghost="item.ghost"
        @click="handleAction(item.action, record)"
      >
        {{ item.title }}
      </a-button>
    </span>
  </span>
</template>

<script>
import { hasPermissions } from '@/permissions/util'

export default {
  name: 'TableActions',
  props: {
    actions: {
      type: Array,
      default () {
        return []
      }
    },
    record: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    list () {
      const list = []

      this.actions.forEach((item) => {
        if (item.apis) {
          if (hasPermissions(this.$store.state.apis, item.apis)) {
            list.push(item)
          }
        } else {
          list.push(item)
        }
      })

      return list
    }
  },
  methods: {
    handleAction (actionType, record) {
      this.$emit(actionType, record)
    },
    successEvent (msg) { // 上传成功文件回调
      this.$emit('import')
    }

  }
}
</script>

<style lang="less">
.table-action {
  .delete {
    color: var(--red);

    button span {
      color: var(--red);
    }
  }

  .action {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  .import {
    display: inline-block;
  }

  .ant-btn-link {
    padding: 0;
  }
}
</style>
